<subpage-layout [showBackButton]="true" (back)="cancel()">
    <div class="pin-change-modal">
        <p class="message">
            A new 5 digit PIN will be randomly generated for the entry portal as well as your apartment door. Your old entry portal PIN and apartment door PIN will no longer work.
        </p>
        
        <div class="actions">
            <ion-button class="primary" expand="block" (click)="confirm()" [disabled]="isLoading">
                <ion-spinner name="dots" *ngIf="isLoading"></ion-spinner>
                <span *ngIf="!isLoading">Continue</span>
            </ion-button>
            
            <ion-button class="secondary" expand="block" (click)="cancel()" [disabled]="isLoading">
                Cancel
            </ion-button>
        </div>
        
        <div class="support">
            <ion-button class="link-styled underlined"
                        (click)="openSupportModal.emit(true)"
                        fill="clear"
                        [disabled]="isLoading">
                Contact Support
            </ion-button>
        </div>
    </div>
</subpage-layout>

<contact-support-form [openModal]="openSupportModal"></contact-support-form> 